module.exports = __webpack_public_path__ + "af61f08492eb6fddfc66700066a9074b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/bookshelves/bookshelf-sports.png
// module id = 1570
// module chunks = 0